export default class TabList {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            const firstTab = document.querySelector('.tab-list .tab');
            const firstContent = document.querySelector('.tab-list .tab-content');
            firstTab.classList.add('active');
            firstContent.classList.add('active');
        })
        function handleTabClick(event) {
            event.preventDefault(); // Prevent default link behavior

            // Remove 'active' class from all tabs and contents
            document.querySelectorAll('.tab-list .tab').forEach(tab => {
                tab.classList.remove('active');
            });
            document.querySelectorAll('.tab-list .tab-content').forEach(content => {
                content.classList.remove('active');
            });

            // Add 'active' class to the clicked tab
            this.classList.add('active');

            // Show the content corresponding to the clicked tab
            const targetId = this.getAttribute('href').substring(1);
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        }

        // Attach click event listener to each tab
        document.querySelectorAll('.tab-list .tab').forEach(tab => {
            tab.addEventListener('click', handleTabClick);
        });

        // Optionally, show the first tab's content by default
        document.querySelector('.tab-list .tab').click();
    }
}
